import React, {FC, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import i18n from 'i18next';
import LoginForm from '@/components/admin/Login/Login';
import isLoggedUseCase from '@/domain/useCases/isLoggedUseCase';
import loginUseCase from '@/domain/useCases/loginUseCase';
import {LoginError} from '@/domain/services/Auth';

const LoginView: FC = () => {
  const navigate = useNavigate();

  const [user, setUsername] = useState('');
  const [pass, setPassword] = useState('');
  const [errors, setErrors] = useState<LoginError>({});

  useEffect(() => {
    if (isLoggedUseCase()){
      navigate(`/${i18n.resolvedLanguage}/`);
    }
  }, []);

  const handleLogin = () => {
    loginUseCase(user, pass)
      .then((result) => {
        if (result) {
          setErrors(result);
        } else {
          navigate(`/${i18n.resolvedLanguage}/`);
        }
      });
  };

  return <LoginForm
    password={pass}
    username={user}
    loginErrors={errors}
    onLoginButtonClicked={handleLogin}
    onPasswordChanged={setPassword}
    onUsernameChanged={setUsername}
  />;
};

export default LoginView;